import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import AllStudents from "./AllStudents";
import StudentDetails from "./StudentDetails";

const EducationStudent = () => {
  return (
    <NavigationDrawer>
      <AllStudents />
      {/* <StudentDetails /> */}
    </NavigationDrawer>
  );
};

export default EducationStudent;
